import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 active:translate-y-[1px] active:shadow-none",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground glow-btn shadow-[0_4px_0_0_rgba(0,0,0,0.25),0_6px_12px_rgba(0,0,0,0.15)] hover:shadow-[0_3px_0_0_rgba(0,0,0,0.25),0_4px_8px_rgba(0,0,0,0.12)] hover:translate-y-[1px] hover:brightness-110",
        destructive:
          "bg-destructive text-destructive-foreground shadow-[0_4px_0_0_rgba(127,29,29,0.5),0_0_15px_rgba(239,68,68,0.3)] hover:shadow-[0_3px_0_0_rgba(127,29,29,0.5),0_0_20px_rgba(239,68,68,0.4)] hover:translate-y-[1px]",
        outline:
          "border border-white/20 bg-white/5 backdrop-blur-sm shadow-[0_4px_0_0_rgba(0,0,0,0.08),0_4px_8px_rgba(0,0,0,0.06)] hover:bg-white/10 hover:border-white/30 hover:text-accent-foreground hover:shadow-[0_3px_0_0_rgba(0,0,0,0.08),0_3px_6px_rgba(0,0,0,0.04)] hover:translate-y-[1px]",
        secondary:
          "bg-secondary text-secondary-foreground shadow-[0_4px_0_0_rgba(0,0,0,0.12),0_0_12px_rgba(16,185,129,0.2)] hover:shadow-[0_3px_0_0_rgba(0,0,0,0.12),0_0_18px_rgba(16,185,129,0.3)] hover:translate-y-[1px]",
        ghost: "hover:bg-white/10 hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
